import React from 'react';
import send from './load.gif';

export default () => {
  return (
    <div>
      <img
        src={send}
        style={{ width: '100px', margin: 'auto', display: 'block' }}
        alt="Enviando..."
      />
    </div>
  );
};
